export default __webpack_public_path__ + "static/media/checkbox-unchecked-icon.7284d1f2.svg";